'use strict'

const PROJECT_LIST_SET = 'PROJECT_LIST_SET'
const PROJECT_CREATE = 'PROJECT_CREATE'
const PROJECT_UPDATE = 'PROJECT_UPDATE'

export default class {
	constructor(api) {
		this._api = api

		this.namespaced = true

		this.state = {
			project_list: [],
			projects: {},
		}

		this.actions = {
			project_list: ({commit}) => {
				this._api.project_list()
					.then((response) => {
						commit(PROJECT_LIST_SET, response.data)
					})
					.catch((error) => {
						commit(PROJECT_LIST_SET, [])
						throw error
					})
			},
		}

		this.mutations = {
			[PROJECT_LIST_SET](state, data) {
				state.project_list = data
				state.projects = Object.assign({}, ...data.map((p) => ({[p.id]: p})))
			},
		}

		this.getters = {
			project_list: (state) => {
				return state.project_list
			}
		}
	}
}